<template>
  <div class="windowHeader">
    <window-header-left :cmp-title="cmpTitle"></window-header-left>
    <div class="left-options">
      <slot name="left-options"></slot>
    </div>
    <div class="windowControlsRight">
      <!--<b-button v-b-toggle.enterCommentCollapse size="sm" variant="dark" class="headerSmallButton"><icon name="minus" scale=".7"></icon></b-button>
      <b-button v-b-toggle.enterCommentCollapse size="sm" variant="dark" type="dark" class="headerSmallButton"><icon name="window-maximize" scale=".7"></icon></b-button>-->
      <slot name="options"></slot>
      <!-- TODO: remove hardcoded array for disabled tools -->
      <span v-if="enabledUnlockTools.indexOf(widgetName) > -1">
        <span v-if="$store.getters['cmp/all'][widgetName]['unlocked']" v-b-tooltip.hover title='No overlap with other windows' @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
          <span v-if="hoverLock" @click="toggleLockWindow">
            <icon scale=".8" name="lock" />
          </span>
          <span v-if="!hoverLock">
            <icon scale=".8" name="unlock" />
          </span>
        </span>

        <span v-else v-b-tooltip.hover title='Allow overlap with other windows' @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
          <span v-if="hoverLock" @click="toggleLockWindow">
            <icon scale=".8" name="unlock" />
          </span>
          <span v-if="!hoverLock">
            <icon scale=".8" name="lock" />
          </span>
        </span>
      </span>

      <b-button @click="$store.getters['cmp/all'][widgetName]['enabled']=false" size="sm" variant="dark" type="dark" class="headerSmallButton" v-b-tooltip.hover title='Close'><icon name="window-close" scale=".7"></icon></b-button>
    </div>
  </div>
</template>

<script>
  import WindowHeaderLeft from '../common/WindowHeaderLeft'
  export default {
    name: 'WindowHeader',
    components: {WindowHeaderLeft},
    // TODO: remove hardcoded array for disabled tools
    data () {
      return {
        enabledUnlockTools: ['layers', 'measure', 'info', 'flow', 'pc', 'tasks', 'reports', 'qa_tool', 'project_stats', 'qa_tool_info', 'history'],
        hoverLock: false,
      }
    },
    props: {
      cmpTitle: {
        default: ""
      },
      widgetName: {
        default: null
      }
    },
    methods: {
      toggleLockWindow() {
        this.$store.getters['cmp/all'][this.widgetName]['unlocked']= !this.$store.getters['cmp/all'][this.widgetName]['unlocked']
        this.$store.getters['cmp/all'][this.widgetName]['loading']= !this.$store.getters['cmp/all'][this.widgetName]['loading']
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/WindowHeader.vue